import request from '@/utils/request'
import router from '@/router'

export default {
    login: async({ dispatch, commit }, user) => {
        await request({ method: 'post', url: '/account/login', data: user })
            .then(res => {
                if (res.data && res.data.token && res.data.profile && res.data.profile.type) {
                    commit('SET_TOKEN', res.data.token)
                    dispatch('addMessage', {
                        message: 'login',
                        type: 'success',
                        locale: true
                    })

                    const redirectPages = {
                        admin: '/payments',
                        leader: '/dashboard',
                        business: '/referral-codes'
                    }
                    router.push(redirectPages[res.data.profile.type])
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('addMessage', {
                        message: err.response.data.message,
                        locale: true
                    })
                }
            })
    },

    forgotPassword: async({ commit, dispatch }, data) => {
        await request({ method: 'post', url: '/account/forgot-password', data })
            .then(res => {
                commit('SET_SHOW_MAIL', true)
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.message) {
                    dispatch('addMessage', {
                        message: error.response.data.message,
                        type: 'error',
                        locale: true
                    }, { root: true })
                }
            })
    },

    resetPassword: async({ dispatch }, data) => {
        await request({ method: 'post', url: '/account/reset-password', data })
            .then(res => {
                if (res.status && res.status === 204) {
                    router.push('/login')
                }
            })
            .catch(_ => {
                dispatch('addMessage', {
                    message: 'tokenInvalid',
                    type: 'error',
                    locale: true
                })
            })
    },

    refillBalance: async({ dispatch, commit }, { accountId, sum, promo }) => {
        return await request({
            method: 'post',
            url: 'refill',
            data: {
                accountId, sum, promo
            }
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    message: promo ? 'refillPromoBalance' : 'refillBalance',
                    type: 'success',
                    locale: true
                }, { root: true })
            }

            return res
        }).catch(err => {
            dispatch('addMessage', {
                message: err.message,
                type: 'error'
            }, { root: true })

            return err
        })
    },

    changeActivity: async({ commit, dispatch }, { id, accountType }) => {
        return request({ method: 'put', url: `account/${id}/change-activity` })
            .then(res => {
                commit(`${accountType}/SET_ACCOUNT_ACTIVITY`, id)
                dispatch('addMessage', {
                    type: 'success',
                    message: 'success'
                })

                return res.status === 204
            })
            .catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('addMessage', {
                        message: err.response.data.message,
                        type: 'error'
                    }, { root: true })
                }
            })
    },

    changePurchased: async({ commit, dispatch }, accountId) => {
        return request({ method: 'patch', url: `account/${accountId}/change-purchased` })
            .then(res => {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'success'
                })

                return res.status
            })
            .catch(err => {
                const message = err.response && err.response.data && err.response.data.message

                if (message) {
                    dispatch('addMessage', {
                        message: err.response.data.message,
                        type: 'error'
                    }, { root: true })
                }
            })
    },

    getUser: async({ commit }) => {
        await request({ method: 'get', url: '/account' })
            .then(res => {
                if (res.data) {
                    if (res.data.phoneNumber) {
                        res.data.phoneNumber = '+' + res.data.phoneNumber
                    }
                    commit('SET_USER', res.data)
                    commit('SET_TYPE', res.data.type)
                    commit('SET_FB', res.data.fb)
                    commit('SET_GOOGLE', res.data.google)
                }
            }).catch(() => {
                commit('SET_USER', null)
            })
    },

    confirmAccount: async({ dispatch, commit }, confirmationCode) => {
        await request({ method: 'get', url: `/account/confirmation/${confirmationCode}` })
            .then(res => {
                if (res.data && res.data.confirmed) {
                    commit('SET_ACCOUNT_CONFIRMATION', res.data.confirmed)
                }
            })
            .catch(_ => {
                commit('SET_ACCOUNT_CONFIRMATION', false)
            })
    },

    logout: async({ commit }) => {
        return await request({ method: 'post', url: '/account/logout' })
            .then(_ => {
                commit('REMOVE_TOKEN')

                router.push('/login')
            }).catch(_ => ({ error: true }))
    },

    getCompletedAccounts: async({ commit }, { query }) => {
        return await request({ method: 'get', url: '/account/completed/list', params: { query }})
            .then(res => {
                if (res.data) {
                    return commit('SET_COMPLETED_ACCOUNTS', res.data)
                }

                commit('SET_COMPLETED_ACCOUNTS', [])
            }).catch(() => {
                commit('SET_COMPLETED_ACCOUNTS', [])
            })
    },

    getCompletedBrands: async({ commit }, { query }) => {
        return await request({ method: 'get', url: '/brands', params: { query }})
            .then(res => {
                if (res.data) {
                    return commit('SET_COMPLETED_BRANDS', res.data)
                }

                commit('SET_COMPLETED_BRANDS', [])
            }).catch(() => {
                commit('SET_COMPLETED_BRANDS', [])
            })
    },

    getCompletedEstablishments: async({ commit }, { query }) => {
        return await request({ method: 'get', url: '/establishments', params: { query }})
            .then(res => {
                if (res.data) {
                    return commit('SET_COMPLETED_ESTABLISHMENTS', res.data)
                }

                commit('SET_COMPLETED_ESTABLISHMENTS', [])
            }).catch(() => {
                commit('SET_COMPLETED_ESTABLISHMENTS', [])
            })
    },

    toggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },

    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    }
}
